export const FONT_SIZE = {
  titleSection: {
    fontSize: '1.5rem',
    lineHeight: '32px',
  },
  titleSubsection: {
    fontSize: '1.125rem',
    lineHeight: '28px',
  },
  textBody: {
    fontSize: '1rem',
    lineHeight: '24px',
  },
  textBodySub: {
    fontSize: '0.875rem',
    lineHeight: '22px',
  },
  textSmall: {
    fontSize: '0.75rem',
    lineHeight: '16px',
  },
};

export const FONT_WEIGHT = {
  bold: '600',
  semiBold: '600',
  regular: '400',
};

export const FONT_FAMILY =
  '"Inter", -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, Arimo, sans-serif';
